<div class="row row-header mb-0">
	<div class="col">
		<h1 data-testid="SUBSYS5_LIST_TITLE_TXT">{{ labels().LIST_COMPONENT_TITLE }}</h1>
	</div>
	<div class="col-12 mt-5">
		<h2 data-testid="SUBSYS5_LIST_SEARCH_TOGGLE" class="search-toggle" [class.active]="!isFiltersCollapsed()"
			(click)="isFiltersCollapsed.set(!isFiltersCollapsed())"
			(keypress)="isFiltersCollapsed.set(!isFiltersCollapsed())">
			{{ labels().LIST_COMPONENT_SEARCH_BTN }}
			<span class="material-icons ms-3">expand_more</span>
		</h2>
	</div>
</div>

<div class="row row-contents">

	<div data-testid="SUBSYS5_LIST_SEARCH_BOX" class="search-sidebar order-xl-1 order-1 col-xl-2"
		[ngbCollapse]="isFiltersCollapsed()">
		<tsp-filters />
	</div>

	<div class="order-xl-2 order-2 col-xl">
		<tsp-list-table [isFiltersCollapsed]="isFiltersCollapsed()" />
	</div>

</div>